/**
 * constants_env  定义系统框架相关的常量
 * @author sin
 * @date 2018-01-12
 *
 */


//系统属性
let env = {
    prod: 'https://api.sgmlms.com',
    dev: 'https://lms-dev.wizlong.com',
    test: 'https://lms-test.wizlong.com',
    local: '',//'http://localhost:3000'
}
let stu_env = {
    prod: 'https://www.sgmlms.com',
    dev: 'https://lms-web-dev.wizlong.com:12998',
    test: 'https://lms-web-test.wizlong.com:12998',
    local: '',//'http://localhost:3000'
}
export const nev_env = {
    prod: 'https://nev.sgmlms.com',
    dev: 'https://nev-dev.sgmlms.com:12997',
    test: 'https://nev-test.sgmlms.com:12997',
    local: ''
}

let hkt_env = {
    prod: 'https://classroom.wizlong.com',
    dev: 'https://classroom-dev.wizlong.com',
    test: 'https://classroom-dev.wizlong.com',
    local: 'https://classroom-dev.wizlong.com',//'http://localhost:3000'
}

//访问地址
export const env_host = process.env && process.env.REACT_APP_ENV ? env[process.env.REACT_APP_ENV] : env['local']

//学员端的地址
export const sys_user_url = process.env && process.env.REACT_APP_ENV ? stu_env[process.env.REACT_APP_ENV] : stu_env['local']

//慧课堂访问地址
export const hkt_env_host = process.env && process.env.REACT_APP_ENV ? hkt_env[process.env.REACT_APP_ENV] : hkt_env['local']

//存储storage的key
export const app_storage_key = 'sgmlms';

//html的title
export const app_html_title = '系统首页 - {title}';

//用户/系统日志记录的key
export const app_user_log_key = app_storage_key + '_user_log_key';
export const app_sys_log_key = app_storage_key + '_sys_log_key';

//系统名字
export const sys_short_name = '管理系统';
export const sys_name_prefix = '上汽通用汽车经销商';
export const sys_name_suffix = '在线学习平台管理系统'
export const sys_full_name = '上汽通用汽车经销商在线学习平台'

//RSA加密密码 公钥
export const sys_public_key = 'MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQCIUGwMEGXHqWwiw92NJzVDy4eiTeOCv270voH1oIP66u3QzrhaXUL6/brPk6xNW95gn/GvGImJ4rdOW1q+cLk61GZM6tkYAo04/7EkrT5K4TleSNvG/ktj3Ox4iv3gcOQiXZkZ+Oi0gfM1Hezcn5DbwTofXnhKis96oiidQvDlkQIDAQAB'

//oss key
export const sys_ali_key = 'CloudAli'
export const sys_ali_endpoint = 'https://oss-cn-shanghai.aliyuncs.com'
export const sys_ali_bucket = 'sgm-lms-plus'
export const sys_ali_region = 'oss-cn-shanghai'
export const sys_ali_partSize = 1 * 102400

export const sys_endpoint = 'admin'

//登录地址的路有
export const sys_login_path = '/sign/login'

//内容 公告分类的id
export const sys_content_category_gg_id = '187'

//获取SGM移动课堂跳转的短链接
export const sys_get_app_link = (url) => { return `${sys_user_url}/#/weChat/share?url=${btoa(url)}&sgmlmsPath=true` }